// extracted by mini-css-extract-plugin
export var createdDate = "_lj-1";
export var divider = "_lj-2";
export var headerDivider = "_lj-3";
export var messagesCard = "_lj-0";
export var messagesContainer = "_lj-7";
export var messagesContainerWrapper = "_lj-4";
export var pointerCapturingButtonBoxes = "_lj-a";
export var showLeftPanelButton = "_lj-9";
export var showMoreButton = "_lj-c";
export var showMoreButtonContainer = "_lj-b";
export var summaryTitle = "_lj-6";
export var systemMessageCardWrapper = "_lj-d";
export var topButtons = "_lj-8";
export var withPadding = "_lj-5";